import { render, staticRenderFns } from "./ConfirmSetting.vue?vue&type=template&id=07448046&scoped=true&"
import script from "./ConfirmSetting.vue?vue&type=script&lang=js&"
export * from "./ConfirmSetting.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSetting.vue?vue&type=style&index=0&id=07448046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07448046",
  null
  
)

export default component.exports